import { CardRow } from 'components/CardRow';
import { push } from 'components/Navigation/navigationRef';
import { Screens, Stacks } from 'components/Navigation/types';
import { useScreenSize } from 'hooks/useScreenSize';
import { useSelector } from 'hooks/useSelector';
import { ScreenSize } from 'lib/constants';
import { theme } from 'lib/theme';
import React from 'react';
import {
  selectAseExplorerOptionShowValidationErrors,
  selectAseExplorerOptionSize,
  selectAseFieldGroupRequiredFieldValues,
  selectAseFieldGroupStats,
  selectAseIsEditable,
} from 'store/assessments/selectors';
import { InstanceParentParams } from 'store/assessments/types';
import { Txt, TxtPreset } from 'components/Txt';
import { View } from 'react-native';
import { pluraliseS } from 'lib/pluralise';
import { CountChips } from '../CountChips';

export const ExplorerRepeatableRow: React.FC<{
  // navigation: ExplorerNavigation;
  groupId: string;
  parent: InstanceParentParams;
}> = ({ groupId, parent }) => {
  const screenSize = useScreenSize();
  const isEditable = useSelector(selectAseIsEditable);
  const groupStats = useSelector((state) =>
    selectAseFieldGroupStats(state, {
      groupId,
      parent,
      inAssessmentOnly: true,
    }),
  );
  const requiredFieldValues = useSelector((state) =>
    selectAseFieldGroupRequiredFieldValues(state, groupId),
  );
  const showValidationErrors = useSelector(
    selectAseExplorerOptionShowValidationErrors,
  );
  const explorerOptionSize = useSelector(selectAseExplorerOptionSize);
  const canNavigate = isEditable || !!groupStats.assessmentInstancesCount;
  const smallExplorer = explorerOptionSize === 'small';
  return (
    <CardRow
      key={groupStats.id}
      navigationIsSelected={{
        name: Screens.ROOT_ASEREPEATABLE,
        params: { groupId: groupStats.id, parent },
      }}
      onPress={
        canNavigate
          ? () =>
              push(Stacks.ROOT, Screens.ROOT_ASEREPEATABLE, {
                groupId,
                parent,
              })
          : undefined
      }
      navigationType={
        canNavigate && screenSize === ScreenSize.large ? 'screen' : undefined
      }
      compact={smallExplorer}
      small={smallExplorer}
    >
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1 }}>
          <Txt preset={TxtPreset.CardRowLabel} presetSmall={smallExplorer}>
            {groupStats.name}
          </Txt>
          <Txt
            preset={TxtPreset.CardRowValueUnder}
            presetSmall={smallExplorer}
            style={{ color: theme.colors.fieldValueText }}
          >
            {isEditable
              ? `${groupStats.assessmentInstancesCount}/${groupStats.allInstancesCount} Added`
              : `${groupStats.assessmentInstancesCount} Added`}
          </Txt>
        </View>
        <CountChips
          questions={groupStats.questionsCount}
          questionsCompleted={groupStats.completedQuestionsCount}
          checklists={groupStats.checklistsCount}
          checklistsCompleted={groupStats.completedChecklistsCount}
          actions={groupStats.actionsCount}
          controls={groupStats.controlsCount}
          unreviewedActions={0}
          unreviewedControls={0}
        />
      </View>
      {!!requiredFieldValues && showValidationErrors && (
        <Txt
          preset={TxtPreset.CardRowValueUnder}
          presetSmall={smallExplorer}
          style={{ color: theme.colors.red }}
        >
          {pluraliseS(requiredFieldValues, 'incomplete field')}
        </Txt>
      )}
    </CardRow>
  );
};
